<template>
  <span v-if="isNotProduction" class="environment-notice" style="position: fixed;bottom: 0px;width: 100%;background: #ff3665;z-index: 99999;opacity: 1;height: 10px;">&nbsp;</span>
  <span v-if="isNotProduction" class="environment-notice" style="position: fixed;top: 0px;width: 100%;background: #ff3665;z-index: 99999;opacity: 1;height: 10px;">&nbsp;</span>

  <!--begin::Header-->
  <div id="kt_app_header" class="app-header" data-kt-sticky="true" data-kt-sticky-activate="{default: false, lg: true}" data-kt-sticky-name="app-header-sticky" data-kt-sticky-offset="{default: false, lg: '300px'}">
    <!--begin::Header container-->
    <div class="app-container container-xxl d-flex align-items-stretch justify-content-between" id="kt_app_header_container">
      <!--begin::Header mobile toggle-->
      <!-- <div class="d-flex align-items-center d-lg-none ms-n3 me-2" title="Show sidebar menu">
        <div class="btn btn-icon btn-color-gray-600 btn-active-color-primary w-35px h-35px" id="kt_app_header_menu_toggle">
          <i class="ki-outline ki-abstract-14 fs-2"></i>
        </div>
      </div> -->
      <!--end::Header mobile toggle-->
      <!--begin::Logo-->
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15" v-if="settings">
        <a href="https://readmylips.be" v-if="selectedCustomer == 1">
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-lg-none" />
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-none d-lg-inline app-sidebar-logo-default theme-light-show" />
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-none d-lg-inline app-sidebar-logo-default theme-dark-show" />
        </a>
        <a href="/" v-else>
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-lg-none" />
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-none d-lg-inline app-sidebar-logo-default theme-light-show" />
          <img alt="Logo" :src="`${settings.logo}`" class="h-45px d-none d-lg-inline app-sidebar-logo-default theme-dark-show" />
        </a>
      </div>
      <!--end::Logo-->
      <!--begin::Header wrapper-->
      <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
        <!--begin::Menu wrapper-->
        <div class="app-header-menu app-header-mobile-drawer align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="app-header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="250px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_header_menu_toggle" data-kt-swapper="true" data-kt-swapper-mode="{default: 'append', lg: 'prepend'}" data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}">
          <!--begin::Menu-->
          <div class="menu menu-rounded menu-active-bg menu-state-primary menu-column menu-lg-row menu-title-gray-700 menu-icon-gray-500 menu-arrow-gray-500 menu-bullet-gray-500 my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0" id="kt_app_header_menu" data-kt-menu="true">
            
          </div>
          <!--end::Menu-->
        </div>
        <!--end::Menu wrapper-->
        <!--begin::Navbar-->
        <div class="app-navbar flex-shrink-0">
          <!--begin::Quick links-->
          <div class="app-navbar-item ms-1 ms-lg-5">
            <div class="container language" style="height: 0px;" v-if="roles && roles.length && user && loggedInIframe == 0">
              <select v-model="selectedCustomer" id="language-select" class="form-control form-control-sm form-control-solid" @change="changeCustomer" style="width: 150px; position:relative; top: -15px;">
                <option v-for="(role, index) in roles" :key="index" :value="role.customer_id">{{ role.customer.name }}</option>
              </select>
            </div>

            <div class="container language" style="height: 0px;">
              <select v-model="selectedLanguage" id="language-select" class="form-control form-control-sm form-control-solid" @change="changeLanguage" style="width: 50px; position:relative; top: -15px;">
                <option v-for="(language, index) in supportedLanguages" :key="index" :value="language">{{ language }}</option>
              </select>
            </div>
          </div>
          <!--end::Quick links-->
          <!--begin::User menu-->
          <div class="app-navbar-item ms-3 ms-lg-5" id="kt_header_user_menu_toggle" v-if="user && loggedInIframe == 0">
            <!--begin::Menu wrapper-->
            <div class="cursor-pointer symbol symbol-35px symbol-md-45px" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <span class="symbol symbol-circle symbol-35px symbol-md-45px avatar" :style="`background: url(${user.image})`" alt="user" style="width: 45px; height: 45px; background-size: 120%; background-position: center; background-repeat: no-repeat; background-color: #11069f;"></span>
              <span class="badge badge-light-danger badge-circle fw-bold fs-7" style="top: -5px; position: absolute; right: -10px;" v-if="unreadCount">{{unreadCount}}</span>
              <span class="badge badge-primary badge-circle fw-bold fs-7" style="bottom: -5px; position: absolute; right: -10px;" v-if="unreadCountBookings">{{unreadCountBookings}}</span>
            </div>
            <!--begin::User account menu-->
            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" data-kt-menu="true">
              <!--begin::Menu item-->
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-50px me-5">
                    <span class="symbol symbol-circle symbol-35px symbol-md-45px" :style="`background: url(${user.image})`" alt="user" style="width: 45px; height: 45px; background-size: 120%; background-position: center; background-repeat: no-repeat; background-color: #11069f;"></span>
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Username-->
                  <div class="d-flex flex-column" v-if="user">
                    <div class="fw-bold align-items-center fs-5">
                      {{user.title}}
                      <br>
                      <span class="badge badge-light-success fw-bold fs-8 px-2 py-1 mb-2">
                        <span v-if="user.id == 1">Superadmin</span>
                        <span v-if="user.id != 1 && currentRole == 1">Admin</span>
                        <span v-if="user.id != 1 && currentRole == 2">User</span>
                      </span>
                    </div>
                  </div>
                  <!--end::Username-->
                </div>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu separator-->
              <div class="separator my-2"></div>
              <!--end::Menu separator-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 2 && user.id && customerType == 1">
                <a href="/chats" class="menu-link px-5">Chats</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="user.id">
                <a href="/bookings" class="menu-link px-5">Bookings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="user.id">
                <a href="/profile" class="menu-link px-5">Profile</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="user.id">
                <a href="/settings" class="menu-link px-5">Settings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="user.id">
                <a href="/change-password" class="menu-link px-5">Change password</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu separator-->
              <div class="separator my-2" v-if="currentRole == 1"></div>
              <!--end::Menu separator-->

              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1 && customerType == 1">
                <a href="/chats" class="menu-link px-5">Chats</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1 && customerType == 2">
                <a href="/admin/meetings/future" class="menu-link px-5">Meetings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1 && customerType == 1">
                <a href="/admin/bookings" class="menu-link px-5">Bookings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1 && customerType == 2">
                <a href="/admin/bookings/acceptedb" class="menu-link px-5">Bookings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1">
                <a href="/admin/assets" class="menu-link px-5">Assets</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1">
                <a href="/admin/categories" class="menu-link px-5">Application settings</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5" v-if="currentRole == 1">
                <a href="/admin/weeks" class="menu-link px-5">Weekplanner</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5 my-1" v-if="currentRole == 1">
                <a href="/admin/stats" class="menu-link px-5">Statistics</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5 my-1" v-if="user.email == 'demo@mail.com'">
                <a :href="`${appurl}_mail-viewer`" target="_blank" class="menu-link px-5">Mails</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5 my-1" v-if="user.user_id == 1">
                <a :href="`/admin/customers`" target="_blank" class="menu-link px-5">Customers</a>
              </div>
              <!--end::Menu item-->
              <!--begin::Menu item-->
              <div class="menu-item px-5">
                <a href="/logout" class="menu-link px-5">Logout</a>
              </div>
              <!--end::Menu item-->
            </div>
            <!--end::User account menu-->
            <!--end::Menu wrapper-->
          </div>

          <div class="app-navbar-item ms-1 ms-lg-5" v-else>
            <div class="container language" style="height: 0px;">
              <a href="/logout" class="menu-link px-5" style="top: -10px; font-weight: bold; color: #4c5778 !important; position: relative;">Login</a>
            </div>
          </div>
          <!--end::User menu-->
          <!--begin::Header menu toggle-->
          <!--end::Header menu toggle-->
        </div>
        <!--end::Navbar-->
      </div>
      <!--end::Header wrapper-->
    </div>
    <!--end::Header container-->
  </div>
  <!--end::Header-->
</template>

<script>
import axios from 'axios';

export default {
  name: 'TopbarComponent',
  props: {
    
  },
  data() {
    return {
      appurl: process.env.VUE_APP_BASE_URL_RAW,
      settings: null,
      user: null,
      userid: null,
      roles: null,
      selectedLanguage: localStorage.getItem('selectedLanguage') || 'en', // Default language
      selectedCustomer: localStorage.getItem('xpertcustomerselected'), // Default language
      customerType: localStorage.getItem('xpertcustomertype'), // Default language
      loggedInIframe: localStorage.getItem('xpertiframe'), // Default language
      supportedLanguages: ['en', 'nl', 'fr'], // List of supported languages
      currentRole: localStorage.getItem('xpertrole'),
      unreadCount: 0,
      unreadCountBookings: 0
    };
  },
  computed: {
    // Compute the current environment
    environment() {
      return process.env.NODE_ENV;
    },
    // Check if the environment is not production
    isNotProduction() {
      return process.env.NODE_ENV !== 'production';
    }
  },
  methods: {
    changeLanguage() {
      // Update the selected language in localStorage
      localStorage.setItem('selectedLanguage', this.selectedLanguage);
      // Update the language in vue-i18n
      this.$i18n.locale = this.selectedLanguage;
    },
    changeCustomer() {
      localStorage.setItem('xpertcustomerselected', this.selectedCustomer);

      const token = localStorage.getItem('xperttoken');
      const instance = axios.create({
        baseURL: this.$baseURL,
        headers: {
          Authorization: `Bearer ${token}`,
          'Customer': localStorage.getItem('xpertcustomerselected')
        }
      });

      /* Get settings */
      instance.get('customer/type')
        .then(response => {
            this.customerType = response.data.type;
            localStorage.setItem('xpertcustomertype', response.data.type);

            console.log(this.customerType);

            location.reload();
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            // Handle the error
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    const role = localStorage.getItem('xpertrole');

    // Check if the current route path contains "/admin"
    if (window.location.href.includes("/admin") && role && role != 1) {
      // Redirect to the home page or any other desired route
      next({ path: "/" });
    } else {
      next();
    }
  },
  mounted() {
    this.loggedInIframe = localStorage.getItem('xpertiframe');
    
    const currentUrl = window.location.href;
    const containsIframe = currentUrl.indexOf("iframe") !== -1;

    if(containsIframe) {
      localStorage.setItem('xpertcustomerselected', 1);
      localStorage.setItem('xpertcustomertype', 1);
      //localStorage.setItem('xperttoken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNDVmMzljODc0NWI0NTQ1NjI0NDEzMjNjOWYyMjAxNGZiY2QzMmU1MjUxMGRkNzM2YzcxMmY3YjJiOGJlMDJhMjAzMWM4MzdlOGQzZTEwNTYiLCJpYXQiOjE3Mjk0OTg4MTUuMjQxMDY4LCJuYmYiOjE3Mjk0OTg4MTUuMjQxMDcsImV4cCI6MTc2MTAzNDgxNS4yMzc2MjUsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.TWm7_0dKHaOfhTkjIHMykt-QG18o6rYmyTR4PHVJ-Tqm5ETylPilT6oZdLF1wdboWxXWNr6hZTbIIpEQFzw6DE5TPlQNZAefpquvZuVBH8bz75JvKnwTlv2Qf38fqCMmJ95L35QALY_nxxV-QWm5ZUSdiqSO4cfTMHRx37f5LqGoYoy6TMIukDuLdcsA-FT6AHckEVhT_SslbyRlCeL8AOqdf3D5UfD1v9LdtLA8SlnJ6Rmx1nO-eWffva0MUHeSH73jiC50IxueSoSOJlWteLA-2G_WavHHkV75gcs7Aa7zS-YXeABC2Sc4vIzM6ThXy1NzMSZvkTVg0OjogNoTRKWTY4jEI7aJzs9bLcfpZSB9yGSiB4HDureTSL-H2XaCgGBfRUheqa48y-o3D6z-AucgD9CToA0tyuG3UR-nzcnUwlinFPoqrhjAcxbSUqHU_eawRrxO8KbrXTt1FTLFxSG3HI7Gr7IYlna01Ytc81MiKWOfeEOuBPsq_NOn_zvBAbqvAIAjtDXyThCquVRNtJsqsOj3DEHIbT1U_GvubuzlCqnBbi-xw8g2PNhvQxjwn5Zgof_NygXRlX-KwpozJKyWiBbBKdue8Rm-_MJMBGGXAnAKqPD_-A4cBSXfzfe4VDxA3blWcxaFv2HR1JfrfF3cDzYpY5fQfzbrZsQVi2c');
    } else {
      setTimeout(function() {
        if(localStorage.getItem('xpertcustomerselected') == 11) {
          document.querySelector('.app-toolbar').style.backgroundColor = '#01a9d3';
        }
      }, 10);
    
      if(localStorage.getItem('selectedLanguage')) {
        this.$i18n.locale = localStorage.getItem('selectedLanguage');
      } else {
        localStorage.setItem('selectedLanguage', 'en');
        this.$i18n.locale = this.selectedLanguage;
      }

      var token = localStorage.getItem('xperttoken');
      const role = localStorage.getItem('xpertrole');
      const userid = localStorage.getItem('xpertuserid');
      //const roles = JSON.parse(localStorage.getItem('xpertroles'));

      if (window.location.href.includes("/admin") && role && role != 1) {
        window.location.href = "/";
      }

      if(!token) {
        token = this.$token;
      }

      if (token) {
        // Set the authorization header with the bearer token
        const instance = axios.create({
          baseURL: this.$baseURL,
          headers: {
            Authorization: `Bearer ${token}`,
            'Customer': localStorage.getItem('xpertcustomerselected')
          }
        });

        instance.get('/customer/type')
        .then(response => {
            this.customerType = response.data.type;
            localStorage.setItem('xpertcustomertype', response.data.type);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            // Handle the error
        });

        /* Get settings */
        instance.get('/admin/settings')
        .then(response => {
          console.log(response);

          this.settings = response.data.settings;

          if(this.settings.application_name) {
            document.title = this.settings.application_name;
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          // Handle the error
        });

        /* Get unclaimed bookings */
        instance.get('admin/booking/unclaimed')
          .then(response => {
              console.log(response);

              this.unreadCountBookings = response.data.unreadCountBookings;

              const unreadCountBookingsEles = document.querySelectorAll('.unreadCountBookings');

              console.log(this.unreadCountBookings );

              if(this.unreadCountBookings != 0) {
                unreadCountBookingsEles.forEach(element => {
                  element.style.display = 'block';
                  element.textContent = this.unreadCountBookings;
                });
              }
          })
          .catch(error => {
              console.error('Error fetching data:', error);
              // Handle the error
          });

        /* Get unread */
        instance.get('chat/unread')
          .then(response => {
              console.log(response);

              this.unreadCount = response.data.unreadCount;

              const unreadcount = document.querySelectorAll('.unreadCount');

              console.log(this.unreadCount );

              if(this.unreadCount != 0) {
                unreadcount.forEach(element => {
                  element.style.display = 'block';
                  element.textContent = this.unreadCount;
                });
              }
          })
          .catch(error => {
              console.error('Error fetching data:', error);
              // Handle the error
          });

        /** Get profile */
        instance.get('/assets/profile')
          .then(response => {
            this.user = response.data.asset;

            const userimages = document.querySelectorAll('.right-side img');

            if (this.user.image) {
              userimages.forEach(element => {
                element.src = this.user.image;
              });
            }

            const usernames = document.querySelectorAll('.right-side .user_name .name');

            usernames.forEach(element => {
              element.textContent = this.user.title;
            });

            /* Disable asset menu on admin and no asset linked */
            if (this.user !== undefined && this.user !== null && typeof this.user === 'object' && 'id' in this.user) {
              const assetBlocks = document.querySelectorAll('.assetmenu');

              // Loop through the selected elements and set their display property to 'block'
              assetBlocks.forEach(element => {
                element.style.display = 'block';
              });
            } else {
              const assetBlocks = document.querySelectorAll('.assetmenu');

              // Loop through the selected elements and set their display property to 'block'
              assetBlocks.forEach(element => {
                element.style.display = 'none';
              });
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });

        /** Get all roles */
        instance.get('roles')
          .then(response => {
              this.roles = response.data.roles;
          })
          .catch(error => {
              console.error('Error fetching data:', error);
              // Handle the error
          });

        const elementsWithClass = document.querySelectorAll('.usermenu');

        // Loop through the selected elements and set their display property to 'block'
        elementsWithClass.forEach(element => {
          element.style.display = 'block';
        });
      } else {
        const elementsWithClass = document.querySelectorAll('.loginmenu');

        // Loop through the selected elements and set their display property to 'block'
        elementsWithClass.forEach(element => {
          element.style.display = 'block';
        });
      }

      if (role && role == 1) {
        const elementsWithClass2 = document.querySelectorAll('.adminmenu');

        // Loop through the selected elements and set their display property to 'block'
        elementsWithClass2.forEach(element => {
          element.style.display = 'block';
        });

        const roles = document.querySelectorAll('.role');

        // Loop through the selected elements and set their display property to 'block'
        roles.forEach(element => {
          element.textContent = 'Administrator';
        });
      }

      if(userid == 1) {
        const elementsWithClass2 = document.querySelectorAll('.sadminmenu');

        // Loop through the selected elements and set their display property to 'block'
        elementsWithClass2.forEach(element => {
          element.style.display = 'block';
        });

        const roles = document.querySelectorAll('.role');

        // Loop through the selected elements and set their display property to 'block'
        roles.forEach(element => {
          element.textContent = 'Super Administrator';
        });
      }
    }
  },
};
</script>